import React from 'react';
import { Grid, Hidden, makeStyles,Box } from '@material-ui/core';
import { Link } from 'react-router-dom';
import TitleText from '../../components/reusableComponents/TitleText';
import whitelogo from '../../assets/images/whitelogo.png'
import BodyText from '../../components/reusableComponents/BodyText';
// import XLScreenFooter from './XLScreenFooter';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    backgroundColor: '#0A1438',
    marginTop: 100,
    paddingTop: 40,
    paddingBottom: 20,
  },
  link: {
    textDecoration: 'none',
    color: '#C4C4C4',
  },
  SolutionDiv: {
    paddingRight: 20,
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
      marginTop: 30,
      paddingRight: 0,
      order: 2,
    },
  },
  ExploreDiv: {
    marginTop: 10,
    paddingRight: 20,
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
      marginTop: 20,
      order: 1,
      paddingRight: 0,
    },
  },
  ExploreinnerDiv: {
    paddingRight: 20,
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
    },
  },
  logoDiv: {
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
      marginTop: 20,
      order: 3,
    },
  },
  logoImage: {
    marginBottom: 40,
    marginTop: 50,
    [theme.breakpoints.down('md')]: {
      marginTop: 0,
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
    },
  },
}));

const Footer = () => {
  const classes = useStyles();
  return (
    <>
      <Hidden xlUp>
        <Grid container className={classes.mainContainer} justify='center'>
          <Grid container style={{ alignItems: 'self-end' }}>
            <Grid item xs={6}>
              <p style={{ fontSize: 36, color: 'white', textAlign: 'right' }}>1800 8890 743</p>
            </Grid>
            <Grid item xs={6} style={{ textAlign: 'center' }}>
              <p style={{
                marginBottom: '12px',
                color: '#d6d6d6',
                fontSize: '14px'
              }}>10:00 AM - 6:00 PM (EST), Monday - Friday</p>
            </Grid>
          </Grid>
          <Box style={{
            border: '1px solid #727272',
            borderRadius: '12px',
            padding: '7px 3px 3px 2px'
          }}>
            <Grid container>
              <Grid item xs={2}></Grid>
              <Grid item xs={8}>
                <p style={{
                  marginBottom: '12px',
                  color: '#d6d6d6',
                  fontSize: '14px'
                }}>Block - B 31, First Floor, Chandigarh Citi Center, VIP Rd, Zirakpur, Punjab 140603     info@marinersforex.com</p>
                {/* <h */}
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
          </Box>
        </Grid>
      </Hidden>
      {/* <Hidden lgDown>
        <XLScreenFooter />
      </Hidden> */}
    </>
  );
};

export default Footer;